import { useState } from "react";
import { Loader2, Sparkles, X, Check, Clock } from "lucide-react";

const PERKS = [
  "Split your list across Woolworths, Coles, ALDI & IGA",
  "See the cheapest basket vs the fewest-stops shop",
  "Weekly specials & multi-buy deals, done for you",
];

export const SubscribeGate = ({ mode = "trial", onStartTrial, onSubscribe, busy, onClose }) => {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const emailOk = /\S+@\S+\.\S+/.test(email);
  const valid = emailOk && (mode === "expired" || pw.length >= 6);
  const expired = mode === "expired";

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm p-3"
      data-testid="sns-subscribe-gate"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md bg-[#FBF7EF] rounded-[28px] overflow-hidden shadow-2xl border border-black/5 animate-in slide-in-from-bottom-4 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`relative px-6 pt-7 pb-8 text-white ${expired ? "bg-[#E4572E]" : "bg-[#2E7D4F]"}`}>
          <button
            onClick={onClose}
            data-testid="sns-gate-close"
            className="absolute top-4 right-4 h-9 w-9 grid place-items-center rounded-full bg-white/15 hover:bg-white/25 transition-colors"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
          <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider bg-white/15 rounded-full px-3 py-1">
            {expired ? <><Clock className="h-3.5 w-3.5" /> Free month ended</> : <><Sparkles className="h-3.5 w-3.5" /> First month free</>}
          </span>
          <h2 className="mt-4 text-3xl font-black leading-tight">
            {expired ? "Keep saving for $1.50/mo" : "Stop overpaying at the checkout."}
          </h2>
          <p className="mt-2 text-white/85 text-sm">
            {expired
              ? "Your free month's up. Subscribe to keep your savings splits."
              : <>Free for 30 days — <span className="font-bold">no card needed</span>. Then $1.50/mo.</>}
          </p>
        </div>

        <div className="px-6 py-6">
          {!expired && (
            <ul className="space-y-2.5 mb-5">
              {PERKS.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-[#2B2A26]">
                  <span className="mt-0.5 h-5 w-5 shrink-0 grid place-items-center rounded-full bg-[#2E7D4F]/10 text-[#2E7D4F]">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          )}

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            data-testid="sns-email-input"
            className="w-full rounded-2xl border-2 border-black/10 bg-white px-4 py-3.5 text-base outline-none focus:border-[#2E7D4F] transition-colors"
          />
          {!expired && (
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              placeholder="Create a password (min 6 chars)"
              data-testid="sns-password-input"
              className="mt-3 w-full rounded-2xl border-2 border-black/10 bg-white px-4 py-3.5 text-base outline-none focus:border-[#2E7D4F] transition-colors"
            />
          )}
          <button
            disabled={!valid || busy}
            onClick={() => (expired ? onSubscribe(email.trim().toLowerCase()) : onStartTrial(email.trim().toLowerCase(), pw))}
            data-testid={expired ? "sns-subscribe-btn" : "sns-start-trial-btn"}
            className={`mt-3 w-full rounded-2xl text-white font-bold py-4 text-base active:translate-y-[2px] disabled:opacity-50 disabled:shadow-none transition-all flex items-center justify-center gap-2 ${
              expired
                ? "bg-[#E4572E] shadow-[0_6px_0_0_#b8431f] active:shadow-[0_4px_0_0_#b8431f]"
                : "bg-[#2E7D4F] shadow-[0_6px_0_0_#1f5c39] active:shadow-[0_4px_0_0_#1f5c39]"
            }`}
          >
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : expired ? "Subscribe — $1.50/mo" : "Start my free month"}
          </button>
          <p className="mt-3 text-center text-[11px] text-black/45">
            {expired ? "Secure checkout by Stripe · Cancel anytime" : "No card required · We'll email your access"}
          </p>
        </div>
      </div>
    </div>
  );
};
